import axios from 'axios';

const config = {
  baseURL: `${process.env.VUE_APP_BASE_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000,
  isAxios: true,
};

/** Creating the instance for axios */
const httpClient = axios.create(config);
export default httpClient;
